import Serializable from "@/core/misc/mixins/Serializable";
import Core         from "@/core/Core";
import Qty          from "@/core/types/Qty";
import DateSimple   from "@/core/types/DateSimple";
import TimeStamp    from "@/core/types/TimeStamp";

/**
 * Запись транша отгрузок позиции заказа: сборка, отгрузка или приёмка.
 *
 * Класс отражает серверный OrderPositionShipmentTrancheRecord — формат
 * применяется только в OrderPositionShipmentsPopup, доменные сущности сюда
 * не тянутся: в попапе нужны лишь тип и id, чтобы открыть карточку.
 */
class OrderPositionShipmentTrancheRecord extends Serializable {
    /** Id документа (сборки, отгрузки или приёмки) */
    public id: number;
    /** Дата создания документа */
    public createdAt: TimeStamp;
    /** Тип записи: assembly | shipment | receipt */
    public name: string;
    /** Тип записи по-русски: Сборка | Отгрузка | Приемка */
    public nameRu: string;
    /** Тип и номер документа отгрузки; у сборок и приёмок — null */
    public nameSecondary: string | null;
    /** Количество по документу */
    public qty: Qty;
    /** Недостача по приёмке; у сборок и отгрузок — null */
    public qtySecondary: Qty | null;
    /** Дата готовности / отгрузки / приёмки */
    public date: DateSimple;
    /** Подпись к дате: Готовности | Отгрузки | Приемки */
    public dateDescription: string;

    static fromServer(data: any, result = new OrderPositionShipmentTrancheRecord()): OrderPositionShipmentTrancheRecord {
        super.fromServer(data, result);

        // ---- super кладёт сырые строки — гидрируем в семантические типы ----
        result.createdAt    = Core.utils.hydrate(data.createdAt, TimeStamp.fromServer)!;
        result.qty          = Core.utils.hydrate(data.qty, Qty.fromServer)!;
        result.qtySecondary = Core.utils.hydrate(data.qtySecondary, Qty.fromServer);
        result.date         = Core.utils.hydrate(data.date, DateSimple.fromServer)!;

        return result;
    }
}

export default OrderPositionShipmentTrancheRecord;